import Camera from '../../src/legacy/Camera';
export default Camera;
